/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-12-01 19:35:12
 */
import piexif from 'piexifjs'
import { readFileAsDataUrl } from '../../utils/imageUtils'

export const readUserComment = async (url: string): Promise<string> => {
  const dataUrl = await fetch(url)
    .then((res) => res.blob())
    .then((blob) => readFileAsDataUrl(blob as File))
  const exifObj = piexif.load(dataUrl as string)
  const userComment = exifObj['Exif'][piexif.ExifIFD.UserComment]

  if (userComment) {
    console.log(18, userComment)
    return userComment.replace(/ASCII/, '').replace(/\x00{3}/, '')
  } else {
    return ''
  }
}

export interface WorkProgressItem {
  color: string
  background: string
  text: string
}

export const workProgress: Record<number, WorkProgressItem> = {
  0: {
    color: '#D83931',
    background: '#FDDBDA',
    text: '严重落后'
  },
  1: {
    color: '#DE7802',
    background: '#FFE7CC',
    text: '稍微落后'
  },
  2: {
    color: '#245BDB',
    background: '#D6E2FF',
    text: '正常'
  },
  3: {
    color: '#2EA121',
    background: '#D6F4D3',
    text: '提前'
  }
}

export interface ThemeColorItem {
  name: string
  color: string
}

export const themeColors: ThemeColorItem[] = [
  {
    name: '红',
    color: '#dd5353'
  },
  {
    name: '黑',
    color: '#4c4c4c'
  },
  {
    name: '蓝',
    color: '#1890ff'
  }
]
